import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface BatchInviteData {
    ApplicantId: string;
    ApplicantName?: string;
    ApplicantEmail?: string;
    ApplicantPhone?: string;
}

interface BatchInviteRoot{
    Data: any;
    data: BatchInviteData[]
}

const initialState: BatchInviteRoot = {
    data: [],
    Data:[],
}

export const batchInviteSlice = createSlice({
    name: 'batchInvite',
    initialState,
    reducers: {
        setAllBatchInvite: (state, action: PayloadAction<BatchInviteData[]>) => {
            
           state.data = action?.payload
        
        },
        removeAllBatchInvite: (state) => {
            state.data = [];
        },
    }
});

export const {setAllBatchInvite, removeAllBatchInvite} = batchInviteSlice.actions;

export default batchInviteSlice.reducer;